import axios from "axios";
import { getAuth } from "firebase/auth";

const base = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, "");
// Si VITE_API_URL est défini => https://.../api ; sinon => "/api" (proxy Vite en dev)
const api = axios.create({
  baseURL: base ? `${base}/api` : "/api",
  // Délai augmenté à 5 min pour supporter les imports lourds (Google Sheets etc.)
  timeout: 5 * 60 * 1000,
  withCredentials: false,
});

// Injecte le token Firebase si l'utilisateur est connecté (optionnel mais safe)
api.interceptors.request.use(async (config) => {
  try {
    const user = getAuth().currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});

export default api;
